import * as classNames from 'classnames'
import * as React from 'react'
import { Route, RouteProps } from 'react-router'
import MainMenu from '../../containers/navigation/MainMenu'
import TopBar from '../../containers/navigation/TopBar'
import { IOrgObj } from '../../types'

interface IRouteWithMenuProps {
  routeProps: RouteProps
  currentOrganization?: IOrgObj
  isAdmin: boolean
}

class RouteWithMenu extends React.Component<IRouteWithMenuProps> {
  public render() {
    const sidebarStyle = { width: '211px' }
    const sidebarClasses = classNames(
      `${
        this.props.isAdmin ? 'admin-sidebar' : ''
      }SideBar overflow-x-hidden overflow-y-scroll user-select-none fixed top-0 bottom-0 left-0 bg-light-grey9 bwidth1 br-light-grey1 z3 invisible-scrollbar`,
      {}
    )

    return (
      <div>
        <div style={sidebarStyle} className={sidebarClasses}>
          <MainMenu location={this.props.routeProps.location} />
        </div>
        <div className='MainContent fixed top-0 bottom-0'>
          <TopBar {...this.props.routeProps} />
          <div className='calculated-height overflow-x-hidden'>
            <Route {...this.props.routeProps} />
          </div>
        </div>
      </div>
    )
  }
}

export default RouteWithMenu



// WEBPACK FOOTER //
// ./src/components/navigation/RouteWithMenu.tsx